const controller = 'FileManagerT';
/** Permission codes for the legacy file manager module. */
export const legacyFileManagerPermissions = {
    user: `${controller}/FileManagerUser`,
};

const flmRequestsController = 'FlmPozadavky';
/** Permission codes for the legacy FLM requests module. */
export const legacyFlmRequestsPermissions = {
    request: `${flmRequestsController}/PozadavekSubjekt`,
    approveRequest: `${flmRequestsController}/SchvalitPozadavek`,
    report: `${flmRequestsController}/SestavaSubjekt`,
    approveReport: `${flmRequestsController}/SchvalitSestava`,
};

const tagsController = 'Jmenovky';
/** Permission codes for the legacy tags module. */
export const legacyTagsPermissions = {
    inseminationTechnicians: `${tagsController}/InseminacniTechnici`,
};

const breedBookController = 'PlemennaKniha';
/** Permission codes for the legacy breed book module. */
export const legacyBreedBookPermissions = {
    tagPK: `${breedBookController}/JmenovkaPK`,
    animalList: `${breedBookController}/SeznamZvirat`,
    bulkAssemblyGeneration: `${breedBookController}/GenerovaniSestav`,
    animalRenumber: `${breedBookController}/PrecislovaniZvirete`,
    etCombination: `${breedBookController}/KombinaceET`,
    animalHistory: `${breedBookController}/HistorieZvirete`,
    genderChange: `${breedBookController}/ZmenaPohlavi`,
    breedingGame: `${breedBookController}/PlemenoHra`,
};

const AaaSubjectController = 'AaaSubjekt';
/** Permission codes for the legacy subject browser module. */
export const legacyAaaSubjectPermissions = {
    listSubjects: `${AaaSubjectController}/SeznamSubjektu`,
};

const legacyBullLineController = 'JmeLinieByka';
/** Permission codes for the legacy bull line module. */
export const legacyBullLinePermissions = {
    bullLine: `${legacyBullLineController}/LinieByka`,
};

const signsController = 'Znaky';
/** Permission codes for the legacy signs module. */
export const legacySignsPermissions = {
    signs: `${signsController}/Znaky`,
};
